import React, { useState, useEffect } from "react";
import { useNavigate, Outlet, useLocation, Link } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  FaBars,
  FaTimes,
  FaUser,
  FaWhatsapp,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import logo1 from "../Images/para.png";

function LandingLayout() {
const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isLandingPage = location.pathname === "/";

  const aboutChildRoutes = ["/history", "/our-team", "/mission-vision"];
const isAboutChildRoute = aboutChildRoutes.includes(location.pathname);

const closeMobileDrawer = () => {
  setMobileMenuOpen(false);
  setMobileAboutOpen(false);
};

const isNavActive = (key) => {
  if (key === "home") {
    return location.pathname === "/" && (!location.hash || location.hash === "#home");
  }
  if (key === "about") {
    return (location.pathname === "/" && location.hash === "#about") || isAboutChildRoute;
  }
  if (key === "services") {
    return location.pathname === "/" && location.hash === "#services";
  }
  if (key === "contact") {
    return location.pathname === "/" && location.hash === "#contact";
  }
  return false;
};

const isSubNavActive = (path) => location.pathname === path;

useEffect(() => {
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
}, []);

useEffect(() => {
  if (window.location.hash) {
    window.history.replaceState(null, "", window.location.pathname);
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }
}, []);

useEffect(() => {
  setMobileMenuOpen(false);
  setMobileAboutOpen(false);
}, [location.pathname, location.hash]);

useEffect(() => {
  if (mobileMenuOpen && (isAboutChildRoute || location.hash === "#about")) {
    setMobileAboutOpen(true);
  }
}, [mobileMenuOpen, isAboutChildRoute, location.hash]);

useEffect(() => {
  if (!mobileMenuOpen) return;

  const previousOverflow = document.body.style.overflow;

  const onKeyDown = (e) => {
    if (e.key === "Escape") {
      setMobileMenuOpen(false);
      setMobileAboutOpen(false);
    }
  };

  document.body.style.overflow = "hidden";
  window.addEventListener("keydown", onKeyDown);

  return () => {
    document.body.style.overflow = previousOverflow;
    window.removeEventListener("keydown", onKeyDown);
  };
}, [mobileMenuOpen]);


  // Navbar scroll effect
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  // Scroll to top on route change / hash scroll on landing
useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 80);
      }
      window.history.replaceState(null, "", location.pathname);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [location.pathname, location.hash]);

const handleLoginClick = () => {
  closeMobileDrawer();
  navigate("/login");
};


const scrollToSection = (id) => {
  closeMobileDrawer();

  if (!isLandingPage) {
    navigate("/", { replace: true });
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
    return;
  }

  // Scroll without adding hash to URL
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  window.history.replaceState(null, "", "/");
};

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      {/* ══ NAVBAR ══ */}
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="nav-main">
          <div className="container">
            <div className="nav-wrapper">
              <div
                className="logo"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/")}
              >
                <div className="logo-icon">
                  <img src={logo1} alt="Paras Roadlines" className="logo-img" />
                </div>
                <div className="logo-text">
                  <h1>PARAS ROADLINES</h1>
                  <span>Transport · Logistics · Excellence</span>
                </div>
              </div>

<button
  type="button"
  className="menu-toggle"
  onClick={() => setMobileMenuOpen(true)}
  aria-label="Open menu"
  aria-expanded={mobileMenuOpen}
>
  <FaBars />
</button>

<div
  className={`mobile-drawer-overlay ${mobileMenuOpen ? "show" : ""}`}
  onClick={closeMobileDrawer}
/>

<aside className={`mobile-drawer ${mobileMenuOpen ? "open" : ""}`}>
  <div className="mobile-drawer-header">
    <div
      className="mobile-drawer-brand"
      onClick={() => {
        closeMobileDrawer();
        navigate("/");
      }}
    >
      <div className="mobile-drawer-logo-box">
        <img src={logo1} alt="Paras Roadlines" className="logo-img" />
      </div>

      <div className="mobile-drawer-brand-text">
        <h3>Paras Roadlines</h3>
        <span>Transport · Logistics · Excellence</span>
      </div>
    </div>

    <button
      type="button"
      className="mobile-drawer-close"
      onClick={closeMobileDrawer}
      aria-label="Close menu"
    >
      <FaTimes />
    </button>
  </div>

  <div className="mobile-drawer-body">
    <button
      type="button"
      className={`mobile-drawer-link ${isNavActive("home") ? "active" : ""}`}
      onClick={() => scrollToSection("home")}
    >
      Home
    </button>

    <div className="mobile-drawer-about">
      <div className="mobile-drawer-about-row">
        <button
          type="button"
          className={`mobile-drawer-link mobile-drawer-about-main ${
            isNavActive("about") ? "active" : ""
          }`}
          onClick={() => scrollToSection("about")}
        >
          About
        </button>

        <button
          type="button"
          className={`mobile-drawer-about-toggle ${
            mobileAboutOpen || isAboutChildRoute ? "open" : ""
          }`}
          onClick={() => setMobileAboutOpen((prev) => !prev)}
          aria-label="Toggle About submenu"
          aria-expanded={mobileAboutOpen || isAboutChildRoute}
        >
          <KeyboardArrowDownIcon fontSize="small" />
        </button>
      </div>

      <div
        className={`mobile-submenu ${
          mobileAboutOpen || isAboutChildRoute ? "open" : ""
        }`}
      >
        <div className="mobile-submenu-inner">
          <Link
            to="/history"
            className={`mobile-submenu-link ${
              isSubNavActive("/history") ? "active" : ""
            }`}
            onClick={closeMobileDrawer}
          >
            History
          </Link>

          <Link
            to="/our-team"
            className={`mobile-submenu-link ${
              isSubNavActive("/our-team") ? "active" : ""
            }`}
            onClick={closeMobileDrawer}
          >
            Our Team
          </Link>

          <Link
            to="/mission-vision"
            className={`mobile-submenu-link ${
              isSubNavActive("/mission-vision") ? "active" : ""
            }`}
            onClick={closeMobileDrawer}
          >
            Mission & Vision
          </Link>
        </div>
      </div>
    </div>

    <button
      type="button"
      className={`mobile-drawer-link ${isNavActive("services") ? "active" : ""}`}
      onClick={() => scrollToSection("services")}
    >
      Services
    </button>

    <button
      type="button"
      className={`mobile-drawer-link ${isNavActive("contact") ? "active" : ""}`}
      onClick={() => scrollToSection("contact")}
    >
      Contact
    </button>
  </div>

  <div className="mobile-drawer-footer">
    <button className="mobile-drawer-login" onClick={handleLoginClick}>
      <FaUser /> Login
    </button>
  </div>
</aside>

<ul className="nav-links">
  {[
    { label: "Home", id: "home" },
    { label: "About", id: "about" },
    { label: "Services", id: "services" },
    { label: "Contact", id: "contact" },
  ].map(({ label, id }) => (
    <li key={id} className={id === "about" ? "about-dropdown" : ""}>
      <a
        href={`/#${id}`}
        className={`${id === "about" ? "about-link" : ""} ${
          isNavActive(id) ? "active" : ""
        }`}
        onClick={(e) => {
          e.preventDefault();
          scrollToSection(id);
        }}
      >
        <span className="about-link-text">{label}</span>
        {id === "about" && (
          <KeyboardArrowDownIcon
            className="about-arrow-icon"
            fontSize="small"
          />
        )}
      </a>

      {id === "about" && (
        <div className="about-dropdown-menu">
          <Link
            to="/our-team"
            className="about-dropdown-item"
            onClick={closeMobileDrawer}
          >
            Our Team
          </Link>
          <Link
            to="/history"
            className="about-dropdown-item"
            onClick={closeMobileDrawer}
          >
            Our History
          </Link>
          <Link
            to="/mission-vision"
            className="about-dropdown-item"
            onClick={closeMobileDrawer}
          >
            Mission & Vision
          </Link>
        </div>
      )}
    </li>
  ))}
</ul>

              <button className="login-btn" onClick={handleLoginClick}>
                <FaUser /> Login
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* ══ PAGE CONTENT ══ */}
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>

      {/* ══ FOOTER ══ */}
      <footer>
        <div className="footer-top">
          <div className="container">
            <div className="footer-grid">
              {/* Brand Column */}
              <div className="footer-brand">
                <div className="footer-brand-top">
                  <div className="footer-brand-logo-box">
                    <img src={logo1} alt="Paras Roadlines" />
                  </div>

                  <div className="footer-brand-content">
                    <h3>PARAS ROADLINES</h3>
                    <span>Transport · Logistics · Excellence</span>
                    <p>
                      India's trusted road freight partner since 1986.
                      Delivering reliability across 100+ cities with a 250+
                      strong fleet.
                    </p>
                  </div>
                </div>

                <div className="footer-social">
                  <a href="#" aria-label="WhatsApp">
                    <FaWhatsapp />
                  </a>
                  <a href="#" aria-label="LinkedIn">
                    <FaLinkedin />
                  </a>
                  <a href="#" aria-label="Twitter">
                    <FaTwitter />
                  </a>
                </div>
              </div>

              {/* Quick Links */}
              <div className="footer-col">
                <h4>Quick Links</h4>
                <ul className="footer-links">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("home");
                      }}
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("about");
                      }}
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("services");
                      }}
                    >
                      Our Services
                    </a>
                  </li>
                  <li>
                    <Link to="/our-team" onClick={() => window.scrollTo(0, 0)}>
                      Our Team
                    </Link>
                  </li>
                  <li>
                    <Link to="/history" onClick={() => window.scrollTo(0, 0)}>
                      Our History
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/mission-vision"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Mission & Vision
                    </Link>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("contact");
                      }}
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>

              {/* Services */}
              <div className="footer-col">
                <h4>Our Services</h4>
                <ul className="footer-links">
                  <li>
                    <a href="#">Full Truck Load</a>
                  </li>
                  <li>
                    <a href="#">Part Truck Load</a>
                  </li>
                  <li>
                    <a href="#">Warehousing Solutions</a>
                  </li>
                  <li>
                    <a href="#">Cargo Insurance</a>
                  </li>
                  <li>
                    <a href="#">Project Logistics</a>
                  </li>
                  <li>
                    <a href="#">LR Forwarding</a>
                  </li>
                </ul>
              </div>

              {/* Contact */}
              <div className="footer-col">
                <h4>Get In Touch</h4>
                <div className="footer-contact-list">
                  <div className="footer-contact-item">
                    <span className="footer-contact-label">Phone</span>
                    <a href="tel:+917999552398">7999552398</a>
                    <a href="tel:+919425234581">9425234581</a>
                    <a href="tel:+917974125386">7974125386</a>
                  </div>

                  <div className="footer-contact-item">
                    <span className="footer-contact-label">Email</span>
                    <a href="mailto:paras_roadlines@rediffmail.com">
                      paras_roadlines@rediffmail.com
                    </a>
                  </div>

                  <div className="footer-contact-item">
                    <span className="footer-contact-label">Address</span>
                    <p className="footer-addr">
                      52, R.S.Shukla Market, Power House,
                      <br />
                      Bhilai - 490 011, Chhattisgarh
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-divider">
          <div className="container">
            <div className="footer-divider-line" />
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <p>© 2026 Paras Roadlines. All rights reserved.</p>
            <p>
              Powered by{" "}
              <a
                href="https://www.yashvitech.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Yashvitech IT Solution PVT. LTD.
              </a>{" "}
              | <a href="tel:8223079476">8223079476</a>
            </p>
          </div>
        </div>
      </footer>

      <style>{`
        /* ══ NAVBAR ══ */
        .navbar{position:fixed;top:0;width:100%;z-index:9999;transition:all .4s;}
        .nav-main{background:rgba(255,255,255,0.92);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);border-bottom:1px solid #e6e8f0;transition:all .4s;}
        .navbar.scrolled .nav-main{box-shadow:0 4px 30px rgba(16,24,40,.08);border-bottom-color:#dcdfec;}
        .nav-wrapper{display:flex;justify-content:space-between;align-items:center;height:68px;}
        .container{max-width:1200px;margin:0 auto;padding:0 clamp(16px,3vw,40px);width:100%;}
        .logo{display:flex;align-items:center;gap:12px;}
        .logo-icon{width:46px;height:46px;overflow:hidden;display:flex;align-items:center;justify-content:center;border:2px solid #eef2ff;background:#eef2ff;border-radius:10px;}
        .logo-img{width:100%;height:100%;object-fit:contain;}
        .logo-text h1{font-size:1.05rem;font-weight:900;letter-spacing:1px;color:#4338ca;line-height:1.2;text-transform:uppercase;}
        .logo-text span{font-size:.55rem;color:#8b8fa3;letter-spacing:2px;text-transform:uppercase;}
        .nav-links{display:flex;gap:2rem;list-style:none;align-items:center;}
        .nav-links a{text-decoration:none;color:#475069;font-weight:600;font-size:.8rem;letter-spacing:.6px;text-transform:uppercase;transition:color .3s;position:relative;padding-bottom:0px;}
        .nav-links a::after{content:'';position:absolute;bottom:-2px;left:0;width:0;height:2px;background:#4f46e5;transition:width .3s;}
        .nav-links a:hover,.nav-links a.active{color:#4f46e5;}
        .nav-links a:hover::after,.nav-links a.active::after{width:100%;}
        .login-btn{background:#4f46e5;color:#fff;border:1.5px solid #4f46e5;padding:8px 18px;font-weight:700;font-size:.78rem;cursor:pointer;display:flex;align-items:center;gap:7px;transition:all .3s;letter-spacing:.6px;text-transform:uppercase;border-radius:8px;}
        .login-btn:hover{background:#4338ca;border-color:#4338ca;box-shadow:0 8px 20px rgba(79,70,229,.28);}
        .login-btn-mobile{display:none;}
        .menu-toggle{display:none;font-size:1.3rem;cursor:pointer;color:#4f46e5;padding:8px;background:transparent;border:none;align-items:center;justify-content:center;}

        /* ══ ABOUT DROPDOWN ══ */
        .about-dropdown{position:relative;display:flex;align-items:center;}
        .about-dropdown::after{content:"";position:absolute;top:100%;left:0;width:100%;height:14px;background:transparent;}
        .about-link{display:inline-flex;align-items:center;gap:2px;line-height:1;}
        .about-link-text{display:inline-block;line-height:normal;}
        .about-arrow-icon{font-size:18px !important;position:relative;top:1px;transition:transform .3s ease;flex-shrink:0;}
        .about-dropdown:hover .about-arrow-icon{transform:rotate(180deg);}
        .about-dropdown-menu{position:absolute;top:calc(100% + 10px);left:-42px;min-width:180px;background:#fff;border-radius:2px;box-shadow:0 12px 26px rgba(0,0,0,.12);border:1px solid rgba(0,0,0,.08);z-index:1000;opacity:0;visibility:hidden;transform:translateY(8px);pointer-events:none;transition:opacity .3s ease,transform .3s ease,visibility .3s ease;}
        .about-dropdown:hover .about-dropdown-menu{opacity:1;visibility:visible;transform:translateY(0);pointer-events:auto;}
        .about-dropdown-item{display:flex;align-items:center;justify-content:flex-start;min-height:40px;padding:12px 20px;text-decoration:none;color:#475069;font-size:.8rem;font-weight:600;letter-spacing:.6px;text-transform:uppercase;white-space:nowrap;text-align:left;line-height:1.2;position:relative;transition:background .2s ease,color .2s ease;}
        .about-dropdown-menu .about-dropdown-item{padding-bottom:5px !important;padding-top:5px !important;}
        .about-dropdown-item:hover{background:#eef2ff;color:#4f46e5;}
        .about-dropdown-item::after{display:none !important;}

        /* ══ FOOTER ══ */
        footer{
        background:#101636;
        font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
        }

        .footer-top{
        padding:2.75rem 0 2.2rem;
        }

        .footer-grid{
        display:grid;
        grid-template-columns:1.65fr 1fr 1fr 1.2fr;
        gap:clamp(1.5rem,3vw,2.75rem);
        align-items:start;
        }

        /* Brand */
            .footer-brand{
        display:flex;
        flex-direction:column;
        align-items:flex-start;
        }

        .footer-brand-top{
        display:flex;
        align-items:flex-start;
        gap:18px;
        margin-bottom:1.1rem;
        }

        .footer-brand-logo-box{
        width:90px;
        height:90px;
        flex-shrink:0;
        border-radius:16px;
        border:2px solid rgba(255,255,255,.12);
        background:rgba(255,255,255,.06);
        display:flex;
        align-items:center;
        justify-content:center;
        padding:8px;
        box-shadow:0 4px 20px rgba(0,0,0,.15);
        }

        .footer-brand-logo-box img{
        width:100%;
        height:100%;
        object-fit:contain;
        filter:brightness(1.05);
        }

        .footer-brand-content{
        text-align:left;
        padding-top:4px;
        }

        .footer-brand-content h3{
        font-size:1.15rem;
        font-weight:900;
        color:#fbbf24;
        letter-spacing:1.5px;
        text-transform:uppercase;
        line-height:1.2;
        margin:0 0 5px;
        }

        .footer-brand-content span{
        display:block;
        font-size:.58rem;
        color:rgba(255,255,255,.35);
        letter-spacing:2.5px;
        text-transform:uppercase;
        margin-bottom:.7rem;
        }

        .footer-brand-content p{
        color:rgba(255,255,255,.45);
        font-size:.8rem;
        line-height:1.8;
        margin:0;
        max-width:420px;
        }

        .footer-social{
        display:flex;
        gap:.55rem;
        }

        .footer-social a{
        width:34px;
        height:34px;
        background:rgba(255,255,255,.05);
        border:1px solid rgba(255,255,255,.12);
        display:flex;
        align-items:center;
        justify-content:center;
        color:rgba(255,255,255,.5);
        transition:all .3s;
        text-decoration:none;
        font-size:.88rem;
        border-radius:8px;
        }

        .footer-social a:hover{
        background:#fbbf24;
        color:#101636;
        border-color:#fbbf24;
        transform:translateY(-2px);
        box-shadow:0 6px 16px rgba(251,191,36,.25);
        }

        /* Footer Columns */
        .footer-col{
        display:flex;
        flex-direction:column;
        align-items:flex-start;
        text-align:left;
        }

        .footer-col h4{
        color:#fbbf24;
        font-size:.6rem;
        font-weight:800;
        letter-spacing:3px;
        text-transform:uppercase;
        margin:0 0 1rem;
        padding-bottom:.65rem;
        border-bottom:2px solid rgba(251,191,36,.15);
        width:100%;
        text-align:left;
        }

        .footer-links{
        list-style:none;
        padding:0;
        margin:0;
        width:100%;
        }

        .footer-links li{
        width:100%;
        margin-bottom:.35rem;
        text-align:left;
        }

        .footer-links li a{
        display:block;
        width:100%;
        text-align:left;
        color:rgba(255,255,255,.5);
        text-decoration:none;
        font-size:.8rem;
        font-weight:500;
        transition:all .25s;
        padding:2px 0;
        position:relative;
        }

        .footer-links li a::before{
        content:'';
        display:inline-block;
        width:0;
        height:1.5px;
        background:#fbbf24;
        vertical-align:middle;
        margin-right:0;
        transition:all .25s;
        }

        .footer-links li a:hover{
        color:#fbbf24;
        padding-left:12px;
        }

        .footer-links li a:hover::before{
        width:8px;
        margin-right:6px;
        }

        /* Contact */
        .footer-contact-list{
        display:flex;
        flex-direction:column;
        gap:.9rem;
        width:100%;
        text-align:left;
        }

        .footer-contact-item{
        display:flex;
        flex-direction:column;
        align-items:flex-start;
        gap:2px;
        text-align:left;
        }

        .footer-contact-label{
        font-size:.55rem;
        font-weight:700;
        letter-spacing:2px;
        text-transform:uppercase;
        color:rgba(255,255,255,.3);
        margin-bottom:2px;
        }

        .footer-contact-item a{
        display:block;
        color:rgba(255,255,255,.5);
        text-decoration:none;
        font-size:.8rem;
        font-weight:500;
        transition:color .25s;
        text-align:left;
        line-height:1.55;
        }

        .footer-contact-item a:hover{
        color:#fbbf24;
        }

        .footer-addr{
        color:rgba(255,255,255,.4);
        font-size:.78rem;
        line-height:1.65;
        margin:0;
        text-align:left;
        }

        /* Divider */
        .footer-divider{
        padding:0;
        }

        .footer-divider-line{
        height:1px;
        background:linear-gradient(
            90deg,
            transparent,
            rgba(255,255,255,.08) 20%,
            rgba(255,255,255,.08) 80%,
            transparent
        );
        }

        /* Bottom */
        .footer-bottom{
        padding:1rem 0;
        }

        .footer-bottom .container{
        display:flex;
        justify-content:space-between;
        align-items:center;
        flex-wrap:wrap;
        gap:.5rem;
        }

        .footer-bottom p{
        color:rgba(255,255,255,.35);
        font-size:.7rem;
        letter-spacing:.4px;
        margin:0;
        }

        .footer-bottom a{
        color:rgba(255,255,255,.5);
        text-decoration:none;
        transition:color .25s;
        }

        .footer-bottom a:hover{
        color:#fbbf24;
        }

        /* Responsive */
        @media(max-width:1100px){
        .footer-grid{
            grid-template-columns:1fr 1fr;
            gap:2rem;
        }

        .footer-brand{
            grid-column:1 / -1;
        }
        }

        @media(max-width:768px){
        .footer-top{
            padding:2.2rem 0 1.8rem;
        }

        .footer-grid{
            grid-template-columns:1fr;
            gap:1.75rem;
        }

        .footer-brand-top{
            gap:12px;
        }

        .footer-brand-logo-box{
            width:48px;
            height:48px;
        }

        .footer-bottom .container{
            justify-content:center;
            text-align:center;
            flex-direction:column;
            gap:.3rem;
        }
        }

        @media(max-width:480px){
        .footer-brand-logo-box{
            width:68px;
            height:68px;
            border-radius:12px;
            padding:5px;
        }

        .footer-brand-content h3{
            font-size:.95rem;
        }
        }

        /* ══ RESPONSIVE ══ */
        .mobile-drawer-overlay,
        .mobile-drawer{
          display:none;
        }
         @media(max-width:768px){
          .menu-toggle{display:flex;}
          .nav-links{display:none;}
          .login-btn{display:none;}
          .login-btn-mobile{display:none;}
          body.drawer-open .floating-whatsapp-button,
          body.drawer-open ._1bpcM,
          body.drawer-open [class*="floating-whatsapp"]{
            z-index:9999 !important;
          }

          .mobile-drawer-overlay{
            display:block;
            position:fixed;
            inset:0;
            background:rgba(16,24,40,.42);
            opacity:0;
            visibility:hidden;
            pointer-events:none;
            transition:opacity .28s ease,visibility .28s ease;
            z-index:1198;
          }

          .mobile-drawer-overlay.show{
            opacity:1;
            visibility:visible;
            pointer-events:auto;
          }

         .mobile-drawer{
          display:flex;
          flex-direction:column;
          position:fixed;
          top:0;
          right:0;
          width:min(88vw,360px);
          height:100vh;
          background:#fff;
          border-left:1px solid #e6e8f0;
          box-shadow:-18px 0 40px rgba(16,24,40,.18);
          transform:translateX(100%);
          transition:transform .32s ease;
          z-index:1199;
        }

        .mobile-drawer.open{
            transform:translateX(0);
          }

          .mobile-drawer-header{
            display:flex;
            align-items:flex-start;
            justify-content:space-between;
            gap:12px;
            padding:18px 18px 16px;
            border-bottom:1px solid #eef2ff;
            background:#fff;
          }

          .mobile-drawer-brand{
            display:flex;
            align-items:center;
            gap:12px;
            min-width:0;
            cursor:pointer;
          }

          .mobile-drawer-logo-box{
            width:54px;
            height:54px;
            flex-shrink:0;
            border-radius:12px;
            overflow:hidden;
            display:flex;
            align-items:center;
            justify-content:center;
            border:2px solid #eef2ff;
            background:#eef2ff;
          }

          .mobile-drawer-brand-text{
            min-width:0;
          }

          .mobile-drawer-brand-text h3{
            margin:0;
            color:#4338ca;
            font-size:.95rem;
            font-weight:900;
            letter-spacing:.8px;
            text-transform:uppercase;
            line-height:1.2;
          }

          .mobile-drawer-brand-text span{
            display:block;
            margin-top:4px;
            color:#8b8fa3;
            font-size:.56rem;
            letter-spacing:1.7px;
            text-transform:uppercase;
            line-height:1.4;
          }

          .mobile-drawer-close{
            width:38px;
            height:38px;
            flex-shrink:0;
            border:1px solid #e6e8f0;
            border-radius:10px;
            background:#fff;
            color:#4f46e5;
            display:flex;
            align-items:center;
            justify-content:center;
            cursor:pointer;
          }

          .mobile-drawer-body{
            flex:1;
            overflow-y:auto;
            padding:8px 18px 16px;
          }

          .mobile-drawer-link{
            width:100%;
            padding:15px 0;
            background:transparent;
            border:none;
            border-bottom:1px solid #eef2ff;
            color:#475069;
            font-size:.84rem;
            font-weight:700;
            letter-spacing:.8px;
            text-transform:uppercase;
            text-align:left;
            cursor:pointer;
            transition:color .25s ease;
          }

          .mobile-drawer-link:hover,
          .mobile-drawer-link.active{
            color:#4f46e5;
          }

          .mobile-drawer-about{
            border-bottom:1px solid #eef2ff;
          }

          .mobile-drawer-about-row{
            display:flex;
            align-items:center;
            gap:10px;
          }

          .mobile-drawer-about-main{
            flex:1;
            border-bottom:none;
          }

          .mobile-drawer-about-toggle{
            width:36px;
            height:36px;
            flex-shrink:0;
            display:flex;
            align-items:center;
            justify-content:center;
            border:1px solid #e6e8f0;
            border-radius:10px;
            background:#fff;
            color:#4f46e5;
            cursor:pointer;
          }

          .mobile-drawer-about-toggle svg{
            transition:transform .25s ease;
          }

          .mobile-drawer-about-toggle.open svg{
            transform:rotate(180deg);
          }

          .mobile-submenu{
            display:grid;
            grid-template-rows:0fr;
            transition:grid-template-rows .28s ease;
          }

          .mobile-submenu.open{
            grid-template-rows:1fr;
          }

          .mobile-submenu-inner{
            overflow:hidden;
            padding:0 0 8px 12px;
          }

          .mobile-submenu-link{
            display:block;
            padding:10px 0;
            color:#6b7280;
            text-decoration:none;
            font-size:.78rem;
            font-weight:600;
            letter-spacing:.5px;
            text-transform:uppercase;
            transition:color .25s ease,padding-left .25s ease;
          }

          .mobile-submenu-link:hover,
          .mobile-submenu-link.active{
            color:#4f46e5;
            padding-left:8px;
          }

          .mobile-drawer-footer{
            margin-top:auto;
            padding:16px 18px 20px;
            border-top:1px solid #e6e8f0;
            background:#fff;
          }

          .mobile-drawer-login{
            display:flex;
            align-items:center;
            justify-content:center;
            gap:8px;
            width:100%;
            background:linear-gradient(135deg,#4f46e5,#4338ca);
            color:#fff;
            border:none;
            padding:12px 20px;
            font-weight:800;
            font-size:.82rem;
            letter-spacing:.9px;
            text-transform:uppercase;
            border-radius:10px;
            cursor:pointer;
            box-shadow:0 10px 24px rgba(79,70,229,.22);
          }

          .footer-grid{grid-template-columns:1fr;gap:1.75rem;}
          .footer-bottom .container{justify-content:center;text-align:center;}
          .footer-brand-logo-box{
            width:76px;
            height:76px;
            border-radius:14px;
            padding:6px;
          }
          .footer-brand-content h3{
            font-size:1.05rem;
          }
          .footer-brand-top{
            gap:14px;
          }
        }
      `}</style>
    </div>
  );
}

export default LandingLayout;
